<template>
    <div class="enterprise-container">
        <achiTitle title="合作科研机构一览" subtitle="以合作促发展 以合作促创新"></achiTitle>
        <!-- 搜索框 -->
        <div class="search-box">
            <el-input v-model="searchQuery" placeholder="搜索企业名称..." prefix-icon="search" clearable @input="handleSearch"
                class="search-input"></el-input>
        </div>

        <!-- 加载状态 -->
        <el-loading v-if="loading" fullscreen text="正在加载企业信息..."></el-loading>

        <!-- 错误提示 -->
        <el-alert v-if="error" title="数据加载失败" :description="error" type="error" show-icon
            class="error-alert"></el-alert>

        <!-- 企业卡片列表 -->
        <div class="enterprise-cards" v-if="!loading && !error">
            <!-- 无数据提示 -->
            <div v-if="filteredEnterprises.length === 0" class="no-results">
                <el-empty description="没有找到匹配的企业"></el-empty>
            </div>

            <!-- 卡片网格 -->
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="enterprise in filteredEnterprises"
                    :key="enterprise.id">
                    <el-card class="enterprise-card" hoverable @click="goToDetail(enterprise)">
                        <div class="card-content">
                            <!-- 企业logo -->
                            <div class="enterprise-logo">
                                <img :src="enterprise.logo" :alt="enterprise.name + 'logo'" class="logo-img"
                                    @error="handleImageError">
                            </div>

                            <!-- 企业名称 -->
                            <h3 class="enterprise-name">{{ enterprise.name }}</h3>

                            <!-- 成果数量 -->
                            <div class="achievement-count">
                                <i class="el-icon-document"></i>
                                <!-- <span>成果数量: {{ enterprise.achievements }}</span> -->
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import achiTitle from '../components/achievement/achi_title.vue';

export default {
    data() {
        return {
            searchQuery: '',
            enterprises: [],
            loading: true,
            error: null
        };
    },
    computed: {
        // 根据搜索词筛选企业
        filteredEnterprises() {
            if (!this.searchQuery) {
                console.log(this.enterprises)
                return this.enterprises;
            }

            const query = this.searchQuery.toLowerCase();
            return this.enterprises.filter(enterprise =>
                enterprise.name.toLowerCase().includes(query)
            );
        }
    },
    mounted() {
        // 组件挂载时加载数据
        this.loadData();
    },
    components: {
        achiTitle
    },
    methods: {
        // 从JSON文件加载数据
        async loadData() {
            try {
                this.loading = true;
                // 读取企业JSON文件
                const response = await this.$httpTemp.get('/mock/enterprises.json');
                // 存储获取的企业数据
                this.enterprises = response;
                this.error = null;
            } catch (err) {
                this.error = '数据加载失败，请稍后重试';
                console.error('加载企业数据出错:', err);
            } finally {
                this.loading = false;
            }
        },
        goToDetail(enterprise) {
            // 跳转到详情页并传递企业ID参数
            this.$router.push({
                name: 'EnterpriseDetail',
                params: { id: enterprise.id }
            });
        },
        // 处理图片加载失败
        handleImageError(e) {
            // 当logo图片加载失败时，使用默认图片
            e.target.src = 'https://picsum.photos/200/200?grayscale';
        },

        // 搜索处理
        handleSearch() {
            // 搜索逻辑由计算属性处理
        }
    }
};
</script>

<style scoped>
.enterprise-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 30px;
}

.search-box {
    margin-bottom: 45px;
    max-width: 750px;
}

.search-input {
    width: 100%;
    font-size: 18px;
}

.error-alert {
    margin-bottom: 30px;
    font-size: 16px;
}

.enterprise-cards {
    margin-top: 30px;
}

.enterprise-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    padding: 15px;
    margin-top: 30px;
}

.enterprise-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
}

.card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 15px;
    text-align: center;
}

.enterprise-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 22.5px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.logo-img {
    min-width: 100%;
    min-height: 100%;
    object-fit: none;
    object-position: center;
}

.enterprise-name {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 22.5px 0;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    /* 允许自动换行 */
    white-space: normal;
    /* 控制长单词或URL的换行方式 */
    word-break: break-all;
    /* 更严格的换行，允许在单词内换行 */
    width: 100%;
}

.achievement-count {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 21px;
    margin-top: auto;
}

.achievement-count .el-icon-document {
    margin-right: 7.5px;
    color: #409eff;
    font-size: 24px;
}

.no-results {
    text-align: center;
    padding: 50px 0;
}
</style>
